import clsx from 'clsx';
import React, { forwardRef, PropsWithChildren } from 'react';
import classes from './container.module.scss';

export type ContainerProps = PropsWithChildren & { className?: string };

export const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, children }, ref) => {
    return (
      <div ref={ref} className={clsx('container-component', classes.root, className)}>
        {children}
      </div>
    );
  }
);
